<template>
  <div class="">
    <div class="title">
      <gl-sub-text>表示条件</gl-sub-text>
    </div>
    <div class="option-inline">
      <label class="option-label">上位</label>
      <md-field class="option-field">
        <md-input
          type="number"
          v-model.number="_limit"
          class="option-input"
          :min="1"
          :max="maxLimit"
          required
        ></md-input>
        <span class="md-helper-text">最大{{ this.maxLimit }}位</span>
      </md-field>
      <label class="option-label">位まで</label>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

export default {
  mixins: [ErrorReport],
  props: {
    limit: {
      type: Number,
    },
    maxLimit: {
      type: Number,
      default: process.env.VUE_APP_UNBRELLA_MAX_LIMIT
        ? Number(process.env.VUE_APP_UNBRELLA_MAX_LIMIT)
        : 50,
    },
  },
  computed: {
    _limit: {
      get() {
        return this.limit
      },
      set(newVal) {
        if (newVal > this.maxLimit) {
          newVal = this.maxLimit
        }
        this.$emit('update:limit', newVal)
      },
    },

    errors() {
      const errors = []

      if (this.limit < 0) {
        errors.push('表示条件を選択してください')
      }
      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.option-inline {
  display: flex;
}
.option-input {
  width: 60px;
}
.option-field {
  width: 60px;
}
.option-label {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: 16px;
  width: 60px;
}
</style>
